import { getDateLocale } from "../i18n";

/**
 * The rewards and entries lists have always shown British day-month dates
 * ("05 Mar, 14:30"). English keeps that look; every other language uses its
 * own locale from the i18n setup.
 */
export function getListDateLocale() {
  const locale = getDateLocale();
  return locale === "en-US" ? "en-GB" : locale;
}
